import { store } from '../vuex'
import { defineRule } from 'vee-validate';

defineRule('email-available', async (value, args) => {
    if (await store.dispatch('users/emailIsValid', value)) {
        return true;
    }
    return 'This email address has already been taken.';
})